<template>
  <div class="bg_login">
    <div class="container">
      <div v-if="screenLeft"  class="container_home__left">
        <div class="text_left_container" v-model="clock">
          {{ clock.timeText }}
        </div>
      </div>
      <div class="container_home__right">
        <div class="container_home__right_inner">
          <div class="text_right_container">
            登录 &nbsp;&nbsp; 通讯管理平台
          </div>
          <div class="temp_container">
            <el-input class="my-input" placeholder="账户" v-model="userForm.userName" ref="userName">
              <i slot="prefix" class="el-input__icon el-icon-user"></i>
            </el-input>
            <el-input class="my-input" @keyup.enter.native="handleEnterKey" placeholder="密码" type="password" show-password v-model="userForm.password"
                      ref="password">
              <i slot="prefix" class="el-input__icon el-icon-lock"></i>

            </el-input>
          </div>


          <el-button type="primary" plain class="btn_login" @click="login()">登录</el-button>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {checkLogin} from "@/api/api";
import {formatDate} from "@/utils/time";

export default {

  name: 'Login',
  data() {
    return {
      userForm: {
        userName: '',
        password: ''
      },
      flag: 'false',
      bigChar: 'false',
      clock: '',
      screenWidth: '',
      screenLeft:true,
    }
  },
  watch: {
    screenWidth: {
      handler: function (val, oldVal) {
        this.screenLeft=val > 800
      }
    },
  },
    created() {
      this.screenWidth = window.innerWidth
      window.addEventListener('resize',this.handleSize,false)
      localStorage.setItem("CurrentUser", '');
      this.clock = formatDate(new Date())
      this.timeStart();
    },
    beforeDestroy() {
      this.timeRitial()
      window.removeEventListener('resize', this.handleSize);
    },
    methods: {
      handleSize(){
        this.screenWidth = window.innerWidth
      },
      timeRitial(){
        if(!window.timer){ window.timer = []}
        window.timer.map(item => {
          clearInterval(item)
        })
      },
      timeStart() {
        this.timeRitial()
        const timerId = setInterval(() => {
          this.clock = formatDate(new Date())
        }, 1000)
        window.timer.push(timerId);
      },

      login() {
        // this.$router.push('/manager');
        if (this.userForm.userName.trim() !== "" && this.userForm.password.trim() !== "") {
          checkLogin(this.userForm).then(res => {
            if (res.data.code === '0000') {
              // console.log()
              this.$store.dispatch("setUser", true);
              localStorage.setItem('token',res.data.data.accessToken)
              localStorage.setItem("Flag", 'isLogin');
              localStorage.setItem("CurrentUser", res.data.data.userName);
              if(res.data.data.organs != null){
                localStorage.setItem("CurrentOrgans", res.data.data.organs);
              }else{
                localStorage.setItem("CurrentOrgans", '');
              }
              this.$router.push('/manager');
            } else {
              this.$message.warning("请检查账号密码是否输入正确");
            }
          })
        } else {
          this.$message.warning("请输入账号密码");
        }
      },
      handleEnterKey(){
        this.login()
      }

    }
  }
</script>

<style scoped>
.bg_login {
  background-image: url("../assets/login.png");
  background-size: 100% 100%;
  min-width: 100%;
  min-height: 100%;
  display: flex;
  align-items: center;
}

.container {
  background-color: #8b9aac;
  width: 1000px;
  height: 500px;
  display: flex;
  margin: auto;
  box-shadow: -5px 5px 10px #303133;
}

.container_home__left {
  /*width: 500px;*/
  height: 100%;
  flex-grow: 1;
  /*flex-shrink: 1;*/

  background-image: url("../assets/login.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  display: flex;
  flex-direction: column;


}

.text_left_container {
  margin: 25px;
  font-size: 18px;
  color: #FFFFFF;
}

.container_home__right {
  /*width: 500px;*/
  flex-grow: 1;
  background-color: #FFFFFF;

  display: flex;
  align-items: center;
  justify-content: center;

}

.container_home__right_inner {
  min-width: 65%;
  min-height: 60%;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 10px;
  justify-content: space-around;
}

.text_right_container {
  font-size: 24px;
}

.my-input {
  font-size: 18px;
  width: 100%;
  margin: 10px 0;
}

.temp_container {
  width: 100%;

  display: flex;
  flex-direction: column;
}

.btn_login {
  width: 100%;
}

</style>

